
  import { defineComponent } from "vue";

  import baseProcessComponent from "@/components/processComponents/BaseProcessComponent.vue";

  export default defineComponent({
    name: "FormGroup",

    extends: baseProcessComponent,

    computed: {
      value: {
        get() {
          return this.$attrs.modelValue || {};
        },

        set(value: any) {
          this.$emit("update:modelValue", value);
        },
      },

      layout(): boolean {
        return this.attributes.layout === "vertical";
      },
    },
  });
